import axios from 'axios'
// let host='api';
// let host = 'http://47.106.192.126/api';
// let host = 'http://192.168.1.173:8000/api';/api/keywords/
let host = 'https://py.ctaiot.com/api'
let hostDlabel = 'https://dlabel.ctaiot.com'
// 获取商品评价信息/api/article/?category=&article_type=1
export const getCategory = params => { return axios.get(`${host}/category/`) }
export const getArticle = params => {
  if (params) { return axios.get(`${host}/article/` + params) } else { return axios.get(`${host}/article/`) }
}
export const getArticleById = params => { return axios.get(`${host}/article/` + params + '/') }
export const getKeywords = params => { return axios.get(`${host}/keywords/`) }
export const putThumbup = params => { return axios.post(`${host}/thumbup/?id=` + params) }
export const getVersionList = params => { return axios.get(`${hostDlabel}/api/grayupdateversion/list.json`) }



// WEBPACK FOOTER //
// ./src/api/api.js